import React from 'react';
import { LinkStyles, Paragraph } from '../../theme';
import { Link } from '@mui/material';

const SelfPayMessage = (): JSX.Element => {
    return (
        <Paragraph>
            Workers' compensation and traveler's insurance are only seen on a self-pay basis.
            Check out our self-pay pricing <Link href='https://perlmanclinic.com/pricing/' target='_blank' style={LinkStyles}>here</Link>.
            We will provide receipts in case patients want to try to get reimbursed from their insurer,
            but we can make no guarantees about reimbursement. That would be between the patient and their
            insurer.
        </Paragraph>
    );
};

export default SelfPayMessage;
